<template>
    <div class="main-tabs">
        <ul>
            <li @click="change_tab('toc')" :class="{ active: active_tab === 'toc' }">
                <a href="javascript:{}">Terms and Conditions</a>
            </li>
            <li @click="change_tab('privacy')" :class="{ active: active_tab === 'privacy' }">
                <a href="javascript:{}">Privacy policy </a>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    name: "page-menu",
    data() {
        return {};
    },
    computed: {
        ...mapState(["active_tab"])
    },
    methods: {
        ...mapMutations(["set_active_tab"]),
        change_tab(tab) {
            if (tab === this.active_tab) {
                return;
            }
            this.set_active_tab(tab);
        }
    }
};
</script>

<style scoped></style>
